import React from 'react';
import * as utils from "../../utils";

import RouterLink from "./router-link";

export default function HostMessageLink() {
  if (!window.host_message) {
    return null;
  }
  return (
    <RouterLink
      className="simple-shadowbox host-message-link"
      to={utils.eventTabUrlPath("rsvp")}
      trackingSrc="host-message-link"
    >
      View Message from Host
    </RouterLink>
  );
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/host-message-link.es6